import TurndownService from 'turndown'
import { gfm } from '@joplin/turndown-plugin-gfm'
import { kLegalCitationIdAttr, kReferenceMarkerIdAttr } from './citation-helpers'

/**
 * Shared TurndownService instance for the artifact editor.
 * Configured with GFM support and all custom serialization rules.
 *
 * Used by MarkdownEditor (markdown ↔ ProseMirror round-trip) and
 * inline-edit-helpers (serialize editor content after accept/insert).
 */
const turndownService = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
})

turndownService.use(gfm)

// Serialize reference marker spans back to [ref_xxx] for round-trip safety.
// Without this rule, Turndown escapes the brackets in citation spans.
turndownService.addRule('referenceMarker', {
  filter: (node) => node.nodeName === 'SPAN' && node.hasAttribute(kReferenceMarkerIdAttr),
  replacement: (_content, node) => {
    const citationId = (node as HTMLElement).getAttribute(kReferenceMarkerIdAttr) || ''
    return `[${citationId}]`
  },
})

// Serialize legal citation spans back to [authority text](ref_xxx). `content` is the
// already-serialized authority markdown (italics intact), so the link form round-trips.
turndownService.addRule('legalCitation', {
  filter: (node) => node.nodeName === 'SPAN' && node.hasAttribute(kLegalCitationIdAttr),
  replacement: (content, node) => {
    const citationId = (node as HTMLElement).getAttribute(kLegalCitationIdAttr) || ''
    return `[${content}](${citationId})`
  },
})

export { turndownService }
